import { TDocumentDefinitions, TDocumentInformation } from "pdfmake/interfaces";

import { basicStyles } from "./default-styles";
import { DocumentContext } from "./document-context";

export function intoCareDocument(
	ctx: DocumentContext,
	def: {
		info: Required<Pick<TDocumentInformation, "title" | "author">>;
		content: TDocumentDefinitions["content"];
		footer: TDocumentDefinitions["footer"];
	},
): TDocumentDefinitions {
	return {
		info: {
			...def.info,
			creator: "Corilus CareConnect",
			producer: "Corilus CareConnect",
		},
		language: ctx.locale,
		pageSize: "A4",
		defaultStyle: basicStyles["defaultStyle"],
		styles: basicStyles,
		content: def.content,
		footer: def.footer,
	};
}
